export default "__VITE_ASSET__Omw94YNT__"